module.exports = __webpack_public_path__ + "static/media/cyberwallet.bfd78351.svg";